/**
 * Will return true if the provided id follows the defined pattern for valid ids
 */
export function isValidPersonId(id: string): boolean {
  return /^\d{9}$/.exec(id) !== null && id !== '000000000';
}

/**
 * Will return true if the provided dimex follows the defined pattern for valid ids
 */
export function isValidPersonDimex(dimex: string): boolean {
  return dimex.length > 0 ? /^1\d{11}$/.test(dimex) : true;
}

/**
 * Will return true if the provided ruc follows the defined valid pattern
 * Only digits separated by two dashes
 * e.g.: 89210-123124-123
 */
export function isValidRuc(ruc: string): boolean {
  return /^(3)([0-9]{9})$/.test(ruc);
}

export function checkIdFormat(idNumber: string, idType: string): string {
  const formatErrorText = 'Su identificación no está en el formato correcto.';
  if (idType === 'N') {
    return isValidPersonId(idNumber) ? '' : formatErrorText;
  }
  if (idType === 'U') {
    return isValidPersonDimex(idNumber) ? '' : formatErrorText;
  }
  return '';
}
